import { ZIndexBuilder } from '@ff/ui/utils/ZIndexBuilder';

const zIndices = new ZIndexBuilder({
  modal: {
    menubarDrawer: {
      menubar: {
        modalBehind: {
          summaryDrawer: {
            navigationBar: {
              summaryButtons: {
                bottomContent: {
                  tooltip: {
                    swiper: {}
                  },
                }
              },
            },
          }
        }
      }
    }
  },
  modalCloseIcon: {}
}).zIndices;

export default zIndices;
